import { Routes, Route, Navigate } from 'react-router-dom';
import {
    VacationRequestPage,
    VacationManagementPage,
    VacationOverviewPage,
} from '@/features/Vacations';
import { VacationModuleGuard } from '@/features/Vacations/components/VacationModuleGuard';
import { VacationApprovalGuard } from '@/features/Vacations/components/VacationApprovalGuard';
import {
    DP_PORTAL_BASE_PATH,
    DP_PORTAL_ROLES,
    DpPortalIndexRedirect,
    DpPortalLayout,
    DpRequestsPage,
    ApprovalsPage,
} from '@/features/DpPortal';
import {
    DataUpdatePage,
    DayOffPage,
    DpAttendancePage,
    HealthPlanPage,
    OvertimePage,
    RaroInvestPage,
    TicketPage,
} from '@/features/DpRequests';
import { RoleBasedRoute } from '../RoleBasedRoute';

export function DpPortalRoutes() {
    return (
        <Routes>
            <Route element={<DpPortalLayout />}>
                <Route index element={<DpPortalIndexRedirect />} />

                <Route
                    path="ferias"
                    element={
                        <VacationModuleGuard redirectTo={DP_PORTAL_BASE_PATH}>
                            <VacationRequestPage />
                        </VacationModuleGuard>
                    }
                />

                <Route path="solicitacoes" element={<DpRequestsPage />} />

                <Route path="solicitacoes/dados" element={<DataUpdatePage />} />

                <Route path="solicitacoes/outros" element={<TicketPage />} />

                <Route
                    path="solicitacoes/day-off"
                    element={
                        <VacationModuleGuard redirectTo={DP_PORTAL_BASE_PATH}>
                            <DayOffPage />
                        </VacationModuleGuard>
                    }
                />

                <Route path="solicitacoes/hora-extra" element={<OvertimePage />} />

                <Route path="solicitacoes/raro-invest" element={<RaroInvestPage />} />

                <Route path="solicitacoes/beneficios" element={<HealthPlanPage />} />

                <Route
                    path="atendimentos"
                    element={
                        <RoleBasedRoute requiredRoles={DP_PORTAL_ROLES.management} redirectTo={DP_PORTAL_BASE_PATH}>
                            <DpAttendancePage />
                        </RoleBasedRoute>
                    }
                />

                <Route
                    path="aprovacoes"
                    element={
                        <VacationApprovalGuard redirectTo={DP_PORTAL_BASE_PATH}>
                            <ApprovalsPage />
                        </VacationApprovalGuard>
                    }
                />

                <Route
                    path="gestao"
                    element={
                        <RoleBasedRoute requiredRoles={DP_PORTAL_ROLES.management} redirectTo={DP_PORTAL_BASE_PATH}>
                            <VacationManagementPage />
                        </RoleBasedRoute>
                    }
                />

                <Route
                    path="dashboard"
                    element={
                        <RoleBasedRoute requiredRoles={DP_PORTAL_ROLES.overview} redirectTo={DP_PORTAL_BASE_PATH}>
                            <VacationOverviewPage />
                        </RoleBasedRoute>
                    }
                />

                <Route path="panorama" element={<Navigate to={`${DP_PORTAL_BASE_PATH}/dashboard`} replace />} />

                <Route path="*" element={<Navigate to={DP_PORTAL_BASE_PATH} replace />} />
            </Route>
        </Routes>
    );
}
